<template>
  <v-dialog v-model="trigger" max-width="768" persistent>
    <v-card>
      <v-card-title class="text-h5 primary white--text">
        {{
          product == null
            ? "Agregar nuevo producto"
            : "Editar " + product.attributes.descripcion
        }}
        <v-spacer></v-spacer>
        <v-btn @click="emitCancel" class="white--text" icon outlined>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-container fluid class="mt-4">
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="productData.codigo"
                  :rules="[required]"
                  dense
                >
                  <template #label>
                    <span>Código<strong class="red--text"> *</strong></span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="productData.descripcion"
                  :rules="[required]"
                  dense
                >
                  <template #label>
                    <span
                      >Descripción<strong class="red--text"> *</strong></span
                    >
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="productData.precio_lista"
                  :rules="[required]"
                  type="number"
                  min="0"
                  dense
                >
                  <template #label>
                    <span
                      >Precio lista<strong class="red--text"> *</strong></span
                    >
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model.number="productData.subfamilia"
                  :items="families"
                  :rules="[required]"
                  dense
                >
                  <template #label>
                    <span>Familia<strong class="red--text"> *</strong></span>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-card flat v-if="product == null">
              <v-card-title class="px-0 pb-4">Factores</v-card-title>
              <v-card-text class="px-0">
                <v-row v-for="f in factors" :key="f.referencia">
                  <v-col
                    cols="12"
                    md="3"
                    v-if="f.referencia == 'KG' || f.referencia == 'M2'"
                  >
                    <v-text-field
                      v-model.number="f.valor"
                      :rules="[required]"
                      type="number"
                      min="0.1"
                      dense
                    >
                      <template #label>
                        <span v-if="f.referencia == 'KG'"
                          >Factor KG<strong class="red--text"> *</strong></span
                        >
                        <span v-if="f.referencia == 'ML'"
                          >Factor ML<strong class="red--text"> *</strong></span
                        >
                        <span v-if="f.referencia == 'M2'"
                          >Factor M2<strong class="red--text"> *</strong></span
                        >
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3" v-else>
                    <v-text-field
                      :disabled="true"
                      label="Factor ML"
                      hint="N/A"
                      persistent-hint
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      :disabled="true"
                      :value="f.referencia"
                      label="Referencia"
                      persistent-hint
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model.number="f.peso_por_unidad"
                      :rules="[required]"
                      type="number"
                      min="0.1"
                      hint="Peso en KG"
                      persistent-hint
                      dense
                    >
                      <template #label>
                        <span v-if="f.referencia == 'M2'"
                          >Peso por M2<strong class="red--text">
                            *</strong
                          ></span
                        >
                        <span v-else
                          >Peso por unidad<strong class="red--text">
                            *</strong
                          ></span
                        >
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-checkbox v-model="f.activo" dense>
                      <template #label>
                        <span class="text-caption"
                          >¿Disponible como unidad?<strong class="red--text">
                            *</strong
                          ></span
                        >
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card flat v-else>
              <v-card-title class="px-0 pb-4">Factores</v-card-title>
              <v-card-text class="px-0">
                <v-row
                  v-for="fac in productData.factores"
                  :key="fac.referencia"
                >
                  <v-col
                    cols="12"
                    md="3"
                    v-if="fac.referencia == 'KG' || fac.referencia == 'M2'"
                  >
                    <v-text-field
                      v-model.number="fac.valor"
                      :rules="[required]"
                      type="number"
                      min="0.1"
                      dense
                    >
                      <template #label>
                        <span v-if="fac.referencia == 'KG'"
                          >Factor KG<strong class="red--text"> *</strong></span
                        >
                        <span v-if="fac.referencia == 'ML'"
                          >Factor ML<strong class="red--text"> *</strong></span
                        >
                        <span v-if="fac.referencia == 'M2'"
                          >Factor M2<strong class="red--text"> *</strong></span
                        >
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3" v-else>
                    <v-text-field
                      :disabled="true"
                      label="Factor ML"
                      hint="N/A"
                      persistent-hint
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      :disabled="true"
                      :value="fac.referencia"
                      label="Referencia"
                      persistent-hint
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model.number="fac.peso_por_unidad"
                      :rules="[required]"
                      type="number"
                      min="0.1"
                      hint="Peso en KG"
                      persistent-hint
                      dense
                    >
                      <template #label>
                        <span v-if="fac.referencia == 'M2'"
                          >Peso por M2<strong class="red--text">
                            *</strong
                          ></span
                        >
                        <span v-else
                          >Peso por unidad<strong class="red--text">
                            *</strong
                          ></span
                        >
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-checkbox v-model="fac.activo" dense>
                      <template #label>
                        <span class="text-caption"
                          >¿Disponible como unidad?<strong class="red--text">
                            *</strong
                          ></span
                        >
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="emitCancel">
          <v-icon>mdi-close-circle-outline</v-icon>Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="accent" :disabled="!valid" @click="emitDataEntered">
          <v-icon>{{ product == null ? "mdi-plus" : "mdi-pencil" }}</v-icon
          >{{ product == null ? "Agregar" : "Editar" }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required } from "@/helpers/formHelpers";
import { httpGet } from "../../../services/apiService";

export default {
  props: {
    product: Object,
    trigger: Boolean,
  },
  data() {
    return {
      valid: false,
      saleByPiece: false,
      factors: [
        {
          activo: true,
          keyObj: "unidad",
          referencia: "PZA",
          peso_por_unidad: 1,
          valor: 1,
        },
        {
          activo: true,
          keyObj: "kilogramo",
          referencia: "KG",
          peso_por_unidad: 1,
          valor: 1,
        },
        {
          activo: true,
          keyObj: "metro_lineal",
          referencia: "ML",
          peso_por_unidad: 1,
          valor: 1,
        },
        {
          activo: true,
          keyObj: "metro_cuadrado",
          referencia: "M2",
          peso_por_unidad: 1,
          valor: 1,
        },
      ],
      factorTypes: [
        { text: "KILOGRAMO", value: "kilogramo" },
        { text: "METRO CUADRADO", value: "metro_cuadrado" },
      ],
      families: [],
      required,
    };
  },
  computed: {
    productData: {
      get() {
        return {
          id: this.product != null ? this.product.id : null,
          codigo: this.product != null ? this.product.attributes.codigo : null,
          descripcion:
            this.product != null ? this.product.attributes.descripcion : null,
          precio_lista:
            this.product != null ? this.product.attributes.precio_lista : null,
          factores:
            this.product != null ? this.product.attributes.factores : null,
          subfamilia:
            this.product != null
              ? this.product.attributes.subfamilia.data.id
              : null,
        };
      },
    },
  },
  methods: {
    processData() {
      let data = { ...this.productData, familia: "otros" };
      data.factores = {};

      for (const f of this.factors) {
        const { keyObj, ...processed } = f;
        data.factores[f.keyObj] = processed;
      }

      if (this.product == null) {
        delete data.id;
      }

      return data;
    },
    emitDataEntered() {
      const body = this.processData();
      (body);
      if (this.product == null) {
        this.$emit("onAddRequest", body);
        return;
      }
      this.$emit("onEditRequest", this.productData);
    },
    emitCancel() {
      this.$emit("onCancel");
    },
    async getFamilies() {
      const { data } = await httpGet("/subfamilias");
      this.families = [];
      for (const d of data?.data) {
        this.families.push({ text: d?.attributes?.nombre, value: d?.id });
      }
    },
  },
  watch: {
    trigger(newVal) {
      if (newVal == false) {
        return;
      }

      this.getFamilies();
    },
  },
};
</script>